<template>
  <b-form-group
    label="Değer & Açıklama"
    :label-for="iKey + '_value'"
  >
    <b-form-input
      :id="iKey + '_value'"
      v-model="dataItem[iKey].value"
      placeholder="Değer & Açıklama"
    />

  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'ProductItemsValueCard',
  components: {
    BFormGroup,
    BFormInput,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['productItems/dataList']
    },
  },
}
</script>
